import type { IFieldLayout } from './IFieldLayout';
import type { ILayoutPreviewItem } from './ILayoutPreviewItem';

/** Поля зразка групи «Перегляд» (прототип v4 sample): ключ підпису й тип ширини. */
const SAMPLE: ReadonlyArray<[string, string]> = [
  ['assignee', 'user'], ['priority', 'select'], ['due', 'date'], ['remaining', 'number'], ['requester', 'text'], ['regNo', 'short'], ['area', 'area'],
  ['iteration', 'iteration'], ['notes', 'textarea'],
];

/** Зразок групи з поточними ширинами (прототип v4 gsPreview): L — увесь рядок, M — дві колонки, S — одна. Чиста функція. */
export function layoutPreview(layout: IFieldLayout): ILayoutPreviewItem[] {
  return SAMPLE.map(([key, type]) => {
    const width = layout.widths[type] ?? 'M';
    return { key, width, span: width === 'L' ? '1 / -1' : width === 'M' ? 'span 2' : 'span 1' };
  });
}
